// PENTING: File ini berisi kunci API dan kredensial sensitif untuk Firebase.
// File ini dibuat secara otomatis saat proses build dan tidak boleh di-commit.
// Pastikan 'firebase-config.ts' ada di dalam file .gitignore Anda.

const _d = (s) => typeof window !== 'undefined' ? atob(s) : Buffer.from(s, 'base64').toString('utf8');

export const firebaseConfig = {
  apiKey: _d("QUl6YVN5QTBreU8xRG1UQWl4MzVBY0d1RU1PdzFIdjViOEVPZDJJ"),
  authDomain: _d("c2lzdGVtLXBlcml6aW5hbi1zYW50cmktMjNiMGQuZmlyZWJhc2VhcHAuY29t"),
  projectId: _d("c2lzdGVtLXBlcml6aW5hbi1zYW50cmktMjNiMGQ="),
  storageBucket: _d("c2lzdGVtLXBlcml6aW5hbi1zYW50cmktMjNiMGQuZmlyZWJhc2VzdG9yYWdlLmFwcA=="),
  messagingSenderId: _d("ODA1NjAyMjUyODE2"),
  appId: _d("MTo4MDU2MDIyNTI4MTY6d2ViOmVkMzM3YzQ5NTJlYjEwZDQwMjkyOTU="),
  measurementId: _d("Ry1CSEVTUFYxNVdG")
};
